/* global Stimulus, Controller */
/* eslint func-names: ["error", "never"] */
/* eslint class-methods-use-this: off */
/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint no-use-before-define: off */
// import "vite/dynamic-import-polyfill";
import PhotoSwipeLightbox from "photoswipe/lightbox"; // eslint-disable-line import/no-unresolved
import PhotoSwipe from "photoswipe";
import "./photoswipe.scss";
import { webpSupport } from "../webpSupport";

Stimulus.register(
  "photoswipe",
  class extends Controller {
    static targets = ["link"];

    initialize() {
      this.webpFallback();
      this.photoswipeInit();
    }

    webpFallback() {
      // Remove data-pswp-srcset attribute for browsers that don't support webp
      if (!webpSupport.test(navigator.userAgent)) {
        this.linkTargets.forEach((el) => {
          delete el.dataset.pswpSrcset;
        });
      }
    }

    /*
     * NOTE: This class method is messy and doesn't follow good practices for stimulus controllers.
     * It should be split in three, but calling methods from methods can be messy too, so leaving it for now.
     * Also consider initializing each slideshow separately, not just adding it to body element
     */

    photoswipeInit() {
      // Allow fullscreen
      const fullscreenAPI = getFullscreenAPI();
      // Set custom icons
      const leftArrowSVGString =
        '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 48 48"><path fill="#444" d="M15.515 20.237l-8.276-8.25 8.25-8.224 1.271 1.245-6.979 6.979 6.979 6.979-1.245 1.271z"/></svg>';
      const zoomInSVGString =
        '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32"><path fill="#444" d="M15.509 14.108a6.761 6.761 0 001.285-3.983c0-1.819-.708-3.528-1.994-4.814s-2.996-1.994-4.814-1.994c-1.819 0-3.528.708-4.814 1.994s-1.994 2.996-1.994 4.814.708 3.528 1.994 4.814a6.764 6.764 0 004.814 1.994 6.753 6.753 0 003.924-1.243l5.034 4.985 1.583-1.599-5.018-4.969zM4.794 10.126c0-2.863 2.329-5.191 5.191-5.191s5.191 2.329 5.191 5.191-2.329 5.191-5.191 5.191-5.191-2.329-5.191-5.191z"/><path fill="#444" d="M12.236 9.376h-1.5v-1.5h-1.5v1.5h-1.5v1.5h1.5v1.5h1.5v-1.5h1.5z"/></svg>';
      const closeSVGString =
        '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32"><path fill="#444" d="M18.984 6.422L13.406 12l5.578 5.578-1.406 1.406L12 13.406l-5.578 5.578-1.406-1.406L10.594 12 5.016 6.422l1.406-1.406L12 10.594l5.578-5.578z"/></svg>';
      // Set custom fullscreen icon
      const fullscreenSVG =
        '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32"><use xlink:href="#pswp__icn-fullscreen-exit"/><use xlink:href="#pswp__icn-fullscreen-request"/><path d="M9.984 15.076l-1.061-1.061-5.924 5.924V15h-1.5v7.5h7.5V21l-4.938-.001zM15 1.499v1.5L19.938 3l-5.923 5.923 1.061 1.061L21 4.06v4.939h1.5v-7.5z" id="pswp__icn-fullscreen-request"/><path d="M1.5 21.439L2.561 22.5l5.924-5.924v4.939h1.5v-7.5h-7.5v1.5l4.938.001zM21.516 9.983v-1.5l-4.938-.001 5.923-5.923-1.061-1.061-5.924 5.924V2.483h-1.5v7.5z" id="pswp__icn-fullscreen-exit" style="display:none"/></svg>';
      // Set options
      const options = {
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: leftArrowSVGString,
        zoomSVG: zoomInSVGString,
        closeSVG: closeSVGString,

        gallery: ".lightbox",
        children: "a",
        bgOpacity: 0.96,
        pswpModule: PhotoSwipe,
        padding: { top: 48, bottom: 72 },
      };
      // Create new instance
      const lightbox = new PhotoSwipeLightbox(options);
      // Add captions
      lightbox.on("uiRegister", function () {
        lightbox.pswp.ui.registerElement({
          name: "custom-caption",
          order: 9,
          isButton: false,
          appendTo: "root",
          html: "Caption text",
          onInit: (el) => {
            lightbox.pswp.on("change", () => {
              const currSlideElement = lightbox.pswp.currSlide.data.element;
              const captionHTML = currSlideElement.dataset.title;
              el.innerHTML = captionHTML || "";
            });
          },
        });
      });

      // Fullscreen register
      lightbox.on("uiRegister", function () {
        lightbox.pswp.ui.registerElement({
          name: "fullscreen-button",
          title: "Toggle fullscreen",
          order: 11,
          isButton: true,
          html: fullscreenSVG,
          onClick: () => {
            toggleFullscreen();
          },
        });
      });

      // Exit full-screen mode when closing the lightbox
      lightbox.on("close", () => {
        if (fullscreenAPI && fullscreenAPI.isFullscreen()) {
          fullscreenAPI.exit();
        }
      });

      lightbox.init();

      // Simple fullscreen API helper, stolen from v5 documentation (Native fullscreen on open)
      function getFullscreenAPI() {
        let api;
        let enterFS;
        let exitFS;
        let elementFS;
        let changeEvent;
        let errorEvent;
        if (document.documentElement.requestFullscreen) {
          enterFS = "requestFullscreen";
          exitFS = "exitFullscreen";
          elementFS = "fullscreenElement";
          changeEvent = "fullscreenchange";
          errorEvent = "fullscreenerror";
        } else if (document.documentElement.webkitRequestFullscreen) {
          enterFS = "webkitRequestFullscreen";
          exitFS = "webkitExitFullscreen";
          elementFS = "webkitFullscreenElement";
          changeEvent = "webkitfullscreenchange";
          errorEvent = "webkitfullscreenerror";
        }
        if (enterFS) {
          api = {
            request(el) {
              if (enterFS === "webkitRequestFullscreen") {
                el[enterFS](Element.ALLOW_KEYBOARD_INPUT);
              } else {
                el[enterFS]();
              }
            },
            exit() {
              return document[exitFS]();
            },
            isFullscreen() {
              return document[elementFS];
            },
            change: changeEvent,
            error: errorEvent,
          };
        }
        return api;
      }

      // Toggle full-screen mode function
      function toggleFullscreen() {
        if (fullscreenAPI) {
          if (fullscreenAPI.isFullscreen()) {
            // Exit full-screen mode
            fullscreenAPI.exit();
            // Toggle "Exit" and "Enter" full-screen SVG icon display
            setTimeout(function () {
              document.getElementById(
                "pswp__icn-fullscreen-exit"
              ).style.display = "none";
              document.getElementById(
                "pswp__icn-fullscreen-request"
              ).style.display = "inline";
            }, 300);
          } else {
            // Enter full-screen mode
            fullscreenAPI.request(document.querySelector(`.pswp`));
            // Toggle "Exit" and "Enter" full-screen SVG icon display
            setTimeout(function () {
              document.getElementById(
                "pswp__icn-fullscreen-exit"
              ).style.display = "inline";
              document.getElementById(
                "pswp__icn-fullscreen-request"
              ).style.display = "none";
            }, 300);
          }
        }
      }
    }
  }
);
